import { useState, MouseEvent, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { useNavigate } from 'react-router-dom';
import './style.css';
import { ListItemIcon, Typography } from '@mui/material';
import Icons from '../../Icon/icons';
import { User } from '../../../shared/types/user';
import { Role } from '../../../shared/types/role';
import { getMe } from '../../../features/search/service/user-service';
import { getRoleById } from '../../../features/search/service/role-service';

export const MenuTop = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [me, setMe] = useState<User | null>(null);
    const [meRole, setMeRole] = useState<Role | null>(null);
    const open = Boolean(anchorEl);
    
    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleHome = () => {
        navigate('/home');
    };

    const handleRoute = () => {
        navigate('/relatorio-pesquisa');
    };

    const handleRouteAdmin = () => {
        if (meRole?.name === 'super-admin') {
            navigate('/admin-painel-causale');
        } else {
            navigate('/admin-painel');
        }
    };

    const handleCompaniesDashboard = () => {
        navigate('/admin-painel/companies-dashboard');
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);

                // Buscar a role pelo role_id
                if (userData.role_id) {
                    const roleData = await getRoleById(userData.role_id);
                    setMeRole(roleData);
                }
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    return (
        <div className="menu-top-container">
            <span className="menu-top-role" onClick={() => navigate('/profile')}>
                Função: {meRole?.description || 'Carregando...'}
            </span>
            <Button
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                className="menu-top-button"
            >
                <Icons iconName="MenuRounded" addTooltip="Menu" color="#3a8d8e" fontSize={27} />
            </Button>
            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                TransitionComponent={Fade}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleHome}>
                    <ListItemIcon>
                        <Icons iconName="Home" addTooltip="Home" color="#3a8d8e" fontSize={27}/>
                    </ListItemIcon>
                    <Typography color="#3a8d8e">Home</Typography>
                </MenuItem>
                <MenuItem onClick={handleRoute}>
                    <ListItemIcon>
                        <Icons iconName="ContentPasteSearch" addTooltip="Gerar Relatório" color="#3a8d8e" fontSize={27}/>
                    </ListItemIcon>
                    <Typography color="#3a8d8e">Gerar Relatório</Typography>
                </MenuItem>
                {me && meRole && (meRole.name === 'empresa' || meRole.name === 'super-admin') && (
                    <MenuItem onClick={handleRouteAdmin}>
                        <ListItemIcon>
                            <Icons iconName="AdminPanelSettings" addTooltip="Painel Administrativo" color="#3a8d8e" fontSize={27}/>
                        </ListItemIcon>
                        <Typography color="#3a8d8e">Painel Administrativo</Typography>
                    </MenuItem>
                )}
                {me && meRole?.name === 'super-admin' && (
                    <MenuItem onClick={handleCompaniesDashboard}>
                        <ListItemIcon>
                            <Icons iconName="Business" addTooltip="Empresas" color="#3a8d8e" fontSize={27}/>
                        </ListItemIcon>
                        <Typography color="#3a8d8e">Empresas</Typography>
                    </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Icons iconName="Logout" addTooltip="Sair" color="#3a8d8e" fontSize={27}/>
                    </ListItemIcon>
                    <Typography color="#3a8d8e">Sair</Typography>
                </MenuItem>
            </Menu>
        </div>
    );
};
